import { Component } from '@angular/core';
import { TranslateDirective, TranslatePipe as NgxTranslatePipe } from '@ngx-translate/core';
import { HrefDirective } from '@tdwb/core';
import { ModalNotificationImageDirective } from '../../image/modal-notification-image.directive';

@Component({
  imports: [
    TranslateDirective,
    NgxTranslatePipe,
    HrefDirective,
    ModalNotificationImageDirective
  ],
  selector: 'td-wb-modal-notification-notification-hub',
  templateUrl: 'modal-notification-notification-hub.component.html',
  styleUrls: [
    '../modal-notification-common.component.scss'
  ]
})
export class ModalNotificationNotificationHubComponent {
}
